import { NavigateOptions } from "react-router-dom";
import { router } from "../routes";
import { FaFilePdf } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";

export function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

const { REACT_APP_S3PUBLIC_URL: S3PUBLIC_URL } = process.env;

export function navigateTo(props: string = "", options: NavigateOptions = {}) {
  return router.navigate(props?.[0] === "/" ? props : `/${props}`, options);
}

export const YesNoToBoolean = (val: string): boolean =>
  String(val).toLowerCase() === "yes";

export const BooleanToYesNo = (val: boolean): string =>
  Boolean(val) ? "Yes" : "No";

export const getPreSignedUrl = ({ claimId, fileName }) => {
  return `${S3PUBLIC_URL}/claims_documentation/CL-${claimId}/photos-consumer/${fileName}`;
};

export function checkAllKeysHaveValue(obj) {
  if (Array.isArray(obj)) {
    return obj.every((item) => checkAllKeysHaveValue(item));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).every((value) => checkAllKeysHaveValue(value));
  } else {
    obj ??= "";
    return obj.toString().length > 0;
  }
}

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export const renderPDFImage = (url) => {
  const fileName = url?.split("/")?.pop();
  const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);
  const ISPDF = extension?.toLowerCase() === "pdf";
  if (!url) return null;
  return ISPDF ? (
    <FaFilePdf className="size-12 object-cover mr-2" key={url} />
  ) : (
    <div className="flex items-center gap-4 mt-1" key={url}>
      <img
        src={url}
        alt=""
        className="size-16 bg-gray-100 rounded-md cursor-pointer object-cover"
      />
    </div>
  );
};

export function getCachedMppId() {
  let mppId: string = getCookie("temp-mpp-id").toString();
  if (!mppId) {
    const uuid = uuidv4();
    const numericPart = uuid.replace(/-/g, "").slice(0, 15);
    mppId = parseInt(numericPart, 16).toString();
    setCookie("temp-mpp-id", mppId);
  }
  return mppId;
}

export const setCookie = (
  cname: string,
  data: string | object,
  { expireDays = 1, parseJson = false } = {}
) => {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${
    parseJson ? JSON.stringify(data) : data
  };${expires};path=/create-claim`;
};

export const getCookie = (cname: string): string => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trimStart();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const clearCookie = (cname) => {
  document.cookie = cname + "=; Max-Age=-99999999;path=/create-claim;";
};

export function deepAssign(path, value, data = {}) {
  let current = { ...data };
  const splittedKey = path.split(".");
  let temp = current;
  splittedKey.forEach((key, index) => {
    if (index === splittedKey.length - 1) {
      temp[key] = value;
    } else {
      temp[key] ||= {};
      temp = temp[key];
    }
  });

  return current;
}

export function getNestedValue(obj, path) {
  const keys = path.split(".");
  let current = obj;

  for (const key of keys) {
    current = current[key];
  }

  return current;
}
